import TopTabs from 'components/generics/buttons/TopTabs';
import { TopTabType } from 'components/generics/buttons/TopTabs/types';
import { PROFILE_TABS } from 'pages/profile/utils';
import React, { HTMLAttributes } from 'react';
import classes from './index.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  onChangeTab: (value: TopTabType) => void;
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
}

const ProfileTabs = ({
  className,
  onChangeTab,
  selectedTab,
  setSelectedTab,
}: Props) => {
  const tabs = Object.values(PROFILE_TABS).map((value) => ({
    value: value,
    label: value,
  }));

  return (
    <div className={className}>
      <TopTabs
        className={classes.topTabs}
        tabClassName={classes.tab}
        selectedTabClassName={classes.selectedTab}
        underlineClassName={classes.underline}
        tabs={tabs}
        onChangeTab={onChangeTab}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
    </div>
  );
};

export default ProfileTabs;
